import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import styles from "./index.module.sass";
import { CompetitionsType, CompetitionTypes } from "../../services/CompetitionsService";
import { currencyNeutreFormatter } from "../../utils/numberFormatter";
import { PrimaryButton } from "@fluentui/react";
import Auth from "../../Auth/Auth";
import { ErrorModal } from "../Modals/ErrorModal";
import { createurl } from "../../utils/createUrl";

interface CompetitionCardProps
{
    competition: CompetitionsType
    toJoin?: boolean;
}

const CompetitionCard: React.FC<CompetitionCardProps> = ({competition, toJoin}) =>
{
    const history = useHistory();
    const isUserSuscribed = Auth.isSubscribed();
    const activePlan = Auth.getActivePlan();
    const user: any = Auth.getUserProfile();

    const [error, setError] = useState({ status: false, message: "" });

    const formatDate = (date: string) =>
    {
        try 
        {
            // Si la fecha contiene 'T' es un datetime, extraer solo la parte de fecha
            const dateOnly = date.includes('T') ? date.split('T')[0] : date;
            // Intentar parsear la fecha de diferentes formas
            let parsedDate: Date;

            if(dateOnly.includes('/'))
            {
                // Formato con barras: puede ser dd/mm/yyyy o mm/dd/yyyy
                const parts = dateOnly.split('/');
                if(parts.length === 3)
                {
                    // Intentar determinar si es dd/mm/yyyy o mm/dd/yyyy
                    const [first, second, third] = parts;

                    // Si el primer número es mayor que 12, debe ser dd/mm/yyyy
                    if(parseInt(first) > 12)
                    {
                        parsedDate = new Date(parseInt(third), parseInt(second) - 1, parseInt(first));
                    }
                    // Si el segundo número es mayor que 12, debe ser mm/dd/yyyy
                    else if(parseInt(second) > 12)
                    {
                        parsedDate = new Date(parseInt(third), parseInt(first) - 1, parseInt(second));
                    }
                    // Si ambos son <= 12, asumir dd/mm/yyyy (formato europeo)
                    else
                    {
                        parsedDate = new Date(parseInt(third), parseInt(second) - 1, parseInt(first));
                    }
                }
                else
                {
                    parsedDate = new Date(dateOnly);
                }
            }
            else
            {
                // Formato ISO o similar
                parsedDate = new Date(dateOnly);
            }

            // Formatear a dd/mm/yyyy
            const day = parsedDate.getDate().toString().padStart(2, '0');
            const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0');
            const year = parsedDate.getFullYear();

            return `${day}/${month}/${year}`;
        }
        catch(error)
        {
            console.warn('Error parsing date:', date, error);
            return date; // Devolver la fecha original si falla el parseo
        }
    };


    const truncateHtml = (html: string, limit: number): string => 
    {
        const textContent = html.replace(/<\/?[^>]+(>|$)/g, ""); // Elimina etiquetas HTML
        if (textContent.length > limit)
        {
            const truncatedText = textContent.substring(0, limit) + "...";
            return truncatedText;
        }
        return textContent;
    }

    const isCompetitionIniciated = () =>
    {
        if(competition?.startDate !== undefined && new Date(competition?.startDate) <= new Date())
        {
            return true;
        }
        else
        {
            return false;
        }
    }

    return(
        <article className={`rounded background-background`}
            style={
            {
                marginRight: "20px",
                boxShadow: "0 0 5px 3px rgb(0 0 0 / 8%)",
                paddingTop: "10px",
                paddingLeft: "16px",
                paddingRight: "16px",
                height: "240px",
                width: "390px",
                marginTop: "5px",
                marginBottom: "5px"
            }}
        >
            <header>
                <div style={
                    {
                        display: "flex",
                        marginTop: "10px",
                        height: "50px",
                        alignContent: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <div style={{display: "flex", flexDirection: "column"}}>
                        <p style={
                            {
                                marginBottom: "0px",
                                fontSize: "16px",
                                fontWeight: "600",
                                wordBreak: "break-word",
                            }}
                        >
                            {competition.name}
                        </p>
                        <span className="color-neutralTertiaryAlt">
                            Del {formatDate(competition.startDate)} al {formatDate(competition.endDate)}
                        </span>
                    </div>
                    <span className={styles.type}>
                        Tipo: {CompetitionTypes[competition.type]}
                    </span>
                </div>
            </header>
            <main dangerouslySetInnerHTML={{ __html: truncateHtml(competition.description ?? "", 400) }}
                style={
                {
                    marginTop: "10px",
                    whiteSpace: "normal",
                    height: "100px"
                }}
            />

            <div style={{position: "relative", width: "100%", height: "190px"}}>
                <footer style={
                    {
                        backgroundColor: "white",
                        width: "100%",
                        fontSize: "14px",
                        fontWeight: "500",
                        display: "flex",
                        justifyContent: "space-between",
                        boxSizing: "border-box",
                    }}
                >
                    <div>
                        <span>
                            {competition.price === 0 && <>Inscripción gratuita</>}
                            {competition.price !== 0 && competition.typeOfPrice === 0 && <>{currencyNeutreFormatter.format(competition.price)} Elements IA</>}
                            {competition.price !== 0 && competition.typeOfPrice === 1 && <>{currencyNeutreFormatter.format(competition.price)} El. Agua</>}
                            {competition.price !== 0 && (competition.typeOfPrice === 2 || competition.typeOfPrice === 3) && <>{currencyNeutreFormatter.format(competition.price)} €</>}
                        </span>
                        <p>Participantes: {competition.isPromocionated === true ? competition.totalParticipantsPromotionated : competition.totalParticipants}</p>
                        {competition.price !== 0 &&
                        (
                            <React.Fragment>
                                <p className={styles.price}>
                                    Bote:{" "}
                                    {competition.typeOfPrice === 0 &&
                                        <React.Fragment>
                                            {competition.isPromocionated === true && <> {currencyNeutreFormatter.format(competition.totalAmountPromotionated)}{" "} Elements IA </>}
                                            {competition.isPromocionated === false && <> {currencyNeutreFormatter.format(competition.totalAmount)}{" "} Elements IA</>}
                                        </React.Fragment>
                                    }
                                    {competition.typeOfPrice === 1 &&
                                        <React.Fragment>
                                            {competition.isPromocionated === true && <> {currencyNeutreFormatter.format(competition.totalAmountPromotionated)}{" "} Elements Agua </>}
                                            {competition.isPromocionated === false && <> {currencyNeutreFormatter.format(competition.totalAmount)}{" "} Elements Agua</>}
                                        </React.Fragment>
                                    }
                                    {(competition.typeOfPrice === 2 || competition.typeOfPrice === 3) &&
                                        <React.Fragment>
                                            {competition.isPromocionated === true && <> {currencyNeutreFormatter.format(competition.totalAmountPromotionated)}{" "} € </>}
                                            {competition.isPromocionated === false && <> {currencyNeutreFormatter.format(competition.totalAmount)}{" "} €</>}
                                        </React.Fragment>
                                    }
                                </p>
                            </React.Fragment>
                        )}
                    </div>
                    {toJoin !== true && <div style={{display: "flex"}}>
                    {
                        (!competition.idUsers.some(e => e === user.id) && new Date(competition?.endDate) >= new Date() && (competition.allowOutdatedIncriptions === true || (competition.allowOutdatedIncriptions === false && !isCompetitionIniciated())))
                        &&
                        <React.Fragment>
                            <PrimaryButton className="rounded" style={{marginLeft: "10px", width: "130px"}}
                                onClick={() =>
                                {
                                    //Es un plan gestionado
                                    if(activePlan.type === 0)
                                    {
                                        setError({status: true, message: "Los planes de tipo gestionado no pueden participar en la competición. Actualmente tienes seleccionado como activo un plan de este tipo."});
                                    }
                                    else
                                    {
                                        isUserSuscribed ? history.push(`/competitions/join/${competition.id}`) : history.push(`/competitions/join/nsv/${competition.id}`);
                                    }
                                }}
                            >
                                Participar
                            </PrimaryButton>
                        </React.Fragment>
                    }
                        <PrimaryButton className="rounded" style={{marginLeft: "10px", width: "130px"}}
                            onClick={() =>
                            {
                                competition.isPromocionated ? history.push(`/competition/${createurl(competition.name)}-${competition.id}`, {competitionId: competition.id}) : history.push(`/competitions/${competition.id}`, {competitionId: competition.id});
                            }}
                        >
                            Ver
                        </PrimaryButton>
                    </div>}
                </footer>
                {/* {competition.price !== 0 && (
                    <footer
                        style={{
                            backgroundColor: "white",
                            width: "100%",
                            fontSize: "14px",
                            fontWeight: "500",
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "0 10px",
                            boxSizing: "border-box",
                            paddingLeft: "20px",
                            paddingRight: "20px",
                            paddingTop: "20px",
                            position: "absolute",
                            bottom: "20px",
                        }}
                    >
                        
                    </footer>
                )} */}
            </div>
            <ErrorModal title="Tu Plan actual no es compatible con la competición" btnSubmitText="Aceptar" showModal={error.status}
                body=
                {
                    <div>
                        <p>{error.message}</p>
                    </div>
                }
                onSubmit={() =>
                {
                    setError({status: false, message: ""});
                }}
                onClose={() =>
                {
                    setError({status: false, message: ""});
                }}
            />
        </article>
    );
};

export default CompetitionCard;